import React from "react";
import { Link } from "react-router-dom";

const Terms: React.FC = () => {
  return (
    <div className="card mb-4">
      <div className="card-body">
        <h2>Terms of Service</h2>
        <p className="text-muted">Last updated: {new Date().getFullYear()}</p>

        <h5>Acceptance</h5>
        <p className="text-muted">By accessing or using TripSplitter, you agree to these Terms of Service. If you do not agree, do not use the service.</p>

        <h5>Use of service</h5>
        <p className="text-muted">TripSplitter provides tools to create and share trip expense data. You are responsible for the information you enter and the participants you invite. Do not use the service to send unsolicited messages.</p>

        <h5>Accounts</h5>
        <p className="text-muted">You must have a valid account (Auth0) to create trips. Protect your account credentials and notify the app owner if you suspect unauthorized access.</p>

        <h5>Content and ownership</h5>
        <p className="text-muted">You retain ownership of the content you create (trip names, expenses, participant lists). You grant TripSplitter a license to host and transmit that content for the purpose of providing the service.</p>

        <h5>Disclaimer</h5>
        <p className="text-muted">TripSplitter is provided "as is" without warranties. We do not guarantee that calculations are error-free. Use the results as guidance and verify amounts before making payments.</p>

        <h5>Limitation of liability</h5>
        <p className="text-muted">To the maximum extent permitted by law, TripSplitter and its maintainers are not liable for damages arising from use of the service.</p>

        <h5>Changes</h5>
        <p className="text-muted">We may update these terms from time to time. Continued use after changes constitutes acceptance.</p>

        <h5>Contact</h5>
        <p className="text-muted">tripsplitter.noreply@gmail.com</p>

        <Link to="/" className="btn btn-secondary mt-3">Back to Trips</Link>
      </div>
    </div>
  );
};

export default Terms;
